import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/img/add.png'
import _imports_1 from '../assets/img/tart.png'


const _hoisted_1 = {
  key: 0,
  class: "home"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1g6pobj6rtho2i31cm0c9n1319e.jpg",
  class: "home-bg",
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1g6pobvnd1jlk1s8i1qdha8do40t.png",
  class: "tree-left",
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1g6pobvnd1ms55l1snb62h1sp7u.png",
  class: "tree-right",
  alt: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1g6pobvnd1guuvlu5q2md045f14.png",
  class: "home-bottom",
  alt: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1g747sp1694u1kes1kub3r212h39.png",
  class: "home-logo",
  alt: ""
}, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "map"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1g76reugk1ps7198nfkr1m9bf3s9.jpg",
  alt: ""
}, null, -1)
const _hoisted_9 = {
  key: 2,
  class: "model"
}
const _hoisted_10 = { class: "content" }
const _hoisted_11 = {
  key: 0,
  class: "enter"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1g6pobvnd19su1kuf1up17do79612.png",
  alt: ""
}, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "enter"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1g6pobvnd19su1kuf1up17do79612.png",
  alt: ""
}, null, -1)
const _hoisted_15 = {
  key: 3,
  class: "camera"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1g748gq3kp261lks180g1pgs14if9.jpg",
  class: "camera-img",
  alt: ""
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "camera-long" }, "长按图片保存", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1g748ll6vk4e8laa4i1t2bkske.jpg",
  class: "camera-save",
  alt: ""
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { id: "container" }, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "container-tip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: ["body", _ctx.isRi ? 'home-hori' : ''],
      style: `z-index: ${ (_ctx.pop && _ctx.pop.content) ? 101 : 1 };`
    }, [
      (!_ctx.video.url && !_ctx.pop.content)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createVNode("img", {
              src: "https://yunyingcdn.thecover.cn/o_1g6pobvndqi51oug1ck4v5lq65s.png",
              class: ["panda", _ctx.isInfi ? 'anpanda' : ''],
              alt: ""
            }, null, 2),
            _createVNode("img", {
              src: "https://yunyingcdn.thecover.cn/o_1g6pobvndvp4d7v1kbc1ac8m4115.png",
              class: ["monkey", _ctx.isInfi ? 'anmonkey' : ''],
              alt: ""
            }, null, 2),
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _createVNode("img", {
              src: "https://yunyingcdn.thecover.cn/o_1g6pobvnd1npa19dp19ev1netrn713.png",
              class: "start",
              alt: "",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleStart && _ctx.handleStart(...args)))
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowMap)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("div", {
              class: "map-point",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleMap && _ctx.handleMap(...args)))
            })
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode("video", {
        id: "video",
        class: "video",
        loop: _ctx.video.loop,
        crossOrigin: "anonymous",
        "webkit-playsinline": "true",
        playsinline: "",
        "x5-playsinline": "",
        src: _ctx.video.url,
        style: _ctx.video.type === 1 ? 'display:none' : ''
      }, [
        _createVNode("source", {
          src: _ctx.video.url
        }, null, 8, ["src"])
      ], 12, ["loop", "src"]), [
        [_vShow, _ctx.video.url && !(_ctx.pop && _ctx.pop.content)]
      ]),
      _withDirectives(_createVNode("div", {
        class: "video-skip",
        style: _ctx.isRi ? 'left: 90vmax;' : '',
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSkipvideo && _ctx.handleSkipvideo(...args)))
      }, "跳过", 4), [
        [_vShow, _ctx.video.url && !(_ctx.pop && _ctx.pop.content)]
      ]),
      (_ctx.pop && _ctx.pop.content)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("img", {
                src: "https://yunyingcdn.thecover.cn/o_1g6pobvnd1k4racb1sd497n1u4m11.png",
                class: "close",
                alt: "",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
              }),
              (_ctx.pop.video)
                ? (_openBlock(), _createBlock("video", {
                    key: 0,
                    src: _ctx.pop.video,
                    loop: "",
                    controls: "",
                    autoplay: "",
                    "webkit-playsinline": "true",
                    playsinline: "",
                    "x5-playsinline": ""
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              (_ctx.pop.image)
                ? (_openBlock(), _createBlock("img", {
                    key: 1,
                    src: _ctx.pop.image,
                    class: "image",
                    alt: ""
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              _createVNode("div", null, [
                _createVNode("div", {
                  class: "info",
                  style: `height: ${ (_ctx.pop.enter || _ctx.pop.camera) ? '35' : '65' }vmin;`
                }, [
                  _createVNode("h1", null, _toDisplayString(_ctx.pop.name), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.pop.content), 1)
                ], 4),
                (_ctx.pop.enter)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode("img", {
                        src: "https://yunyingcdn.thecover.cn/o_1g6pobvnd3q01tfs1ecl11pu98dv.png",
                        alt: "",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args)))
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.pop.camera)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode("img", {
                        src: "https://yunyingcdn.thecover.cn/o_1g7489o3lh3t4s91dkb1p952vpe.png",
                        alt: "",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleCamera && _ctx.handleCamera(...args)))
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCamera)
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _hoisted_18,
            _createVNode("img", {
              src: "https://yunyingcdn.thecover.cn/o_1g748sb90p831nth16sd1eu0uhtj.png",
              class: "camera-restart",
              alt: "",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleRestart && _ctx.handleRestart(...args)))
            })
          ]))
        : _createCommentVNode("", true)
    ], 6),
    _withDirectives(_createVNode("div", null, [
      _hoisted_19,
      (!(_ctx.pop && _ctx.pop.content))
        ? (_openBlock(), _createBlock("div", _hoisted_20, "滑动屏幕，寻找雨林中的朋友"))
        : _createCommentVNode("", true),
      (!(_ctx.pop && _ctx.pop.content))
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            class: ["container-zoom", _ctx.isRi ? 'zoom-hori' : '']
          }, [
            _createVNode("img", {
              src: _imports_0,
              alt: "",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleCameraZoom(5)))
            }),
            _createVNode("img", {
              src: _imports_1,
              alt: "",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleCameraZoom(-5)))
            })
          ], 2))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.video.type === 1]
    ])
  ], 64))
}